<template>
    <div class="app flex-row align-items-center" id="login-form">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-6">
                    <div class="card-group mb-0">
                        <div class="card p-4">
                            <div class="card-block">
                                <div id="login-logo"><img src="/static/img/logo.png"/></div>
                                <div :class="error ? 'input-group mb-3 has-danger has-feedback' : 'input-group mb-3'">
                                    <span class="input-group-addon"><i class="fa fa-user"></i></span>
                                    <input type="text"
                                           :class="error ? 'form-control form-control-danger' : 'form-control'"
                                           :placeholder='$t("auth.login")' v-model="credentials.username" v-bind:disabled="this.authLoading" required>
                                </div>
                                <div :class="error ? 'input-group mb-3 has-danger has-feedback' : 'input-group mb-3'">
                                    <span class="input-group-addon"><i class="fa fa-lock"></i></span>
                                    <input type="password"
                                           :class="error ? 'form-control form-control-danger' : 'form-control'"
                                           :placeholder='$t("auth.password")' v-model="credentials.password" v-bind:disabled="this.authLoading" required
                                           @keyup.enter="login()">
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="alert alert-danger" v-show="error">
                                            {{ error }}
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <button type="button" class="btn btn-primary px-4" @click="login()"
                                                v-bind:disabled="this.authLoading">{{ $t("auth.login_action") }} <i class="fa fa-spinner fa-spin" aria-hidden="true" v-show="this.authLoading"></i>
                                        </button>
                                    </div>
                                    <div class="col-md-6">
                                        <Language></Language>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import auth from './../../api/Auth.js'
  import Language from './../../i18n/Language.vue'

  export default {
    name: 'Login',
    components: {
      Language
    },
    data: function () {
      return {
        credentials: {
          username: '',
          password: ''
        },
        error: false,
        authLoading: false
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        return auth.user.authenticated ? this.$router.push('/') : null
      })
    },
    methods: {
      login () {
        auth.login(this)
        this.error = false
        this.authLoading = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?7ad12fa1